// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__172ZZ","approved":"Status_approved__3cIGT","rejected":"Status_rejected__M6EOe","expired":"Status_expired__aCB_A","label":"Status_label__ww5zU"};